import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "mx-3" }
const _hoisted_2 = { class: "card mb-4" }
const _hoisted_3 = { class: "row m-3 align-items-center" }
const _hoisted_4 = {
  key: 0,
  class: "col-auto"
}
const _hoisted_5 = { class: "ms-2 mb-0" }
const _hoisted_6 = {
  key: 1,
  class: "col-auto"
}
const _hoisted_7 = { class: "col-auto" }
const _hoisted_8 = { class: "col-auto" }
const _hoisted_9 = { class: "mx-3 mb-2" }
const _hoisted_10 = {
  key: 0,
  class: "mx-3 mb-2 d-flex align-items-center gap-2 flex-wrap"
}
const _hoisted_11 = { class: "text-sm text-secondary" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-1",
  role: "status",
  "aria-hidden": "true"
}
const _hoisted_14 = { class: "card-body px-0 pt-0 pb-2" }
const _hoisted_15 = { class: "table-responsive p-0" }
const _hoisted_16 = {
  key: 0,
  class: "text-center py-2 text-secondary text-xs"
}
const _hoisted_17 = { style: {"width":"40px"} }
const _hoisted_18 = { class: "form-check mb-0 d-flex align-items-center justify-content-center" }
const _hoisted_19 = ["checked", ".indeterminate"]
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { class: "text-uppercase text-secondary text-xxs font-weight-bolder" }
const _hoisted_22 = { class: "text-uppercase text-secondary text-xxs font-weight-bolder" }
const _hoisted_23 = { class: "text-uppercase text-secondary text-xxs font-weight-bolder" }
const _hoisted_24 = { class: "text-uppercase text-secondary text-xxs font-weight-bolder" }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { class: "text-uppercase text-secondary text-xxs font-weight-bolder" }
const _hoisted_29 = { class: "form-check mb-0 d-flex align-items-center justify-content-center" }
const _hoisted_30 = ["checked", "onChange"]
const _hoisted_31 = { class: "py-0" }
const _hoisted_32 = { class: "d-flex px-2 py-1" }
const _hoisted_33 = ["src"]
const _hoisted_34 = {
  key: 1,
  class: "avatar avatar-sm me-3 bg-gradient-secondary"
}
const _hoisted_35 = { class: "d-flex flex-column justify-content-center" }
const _hoisted_36 = { class: "mb-0 text-sm" }
const _hoisted_37 = { class: "text-xs text-secondary mb-0" }
const _hoisted_38 = { class: "text-xs font-weight-bold mb-0" }
const _hoisted_39 = { class: "py-0" }
const _hoisted_40 = { class: "d-flex px-2 py-1" }
const _hoisted_41 = { key: 0 }
const _hoisted_42 = ["src"]
const _hoisted_43 = { class: "d-flex flex-column justify-content-center" }
const _hoisted_44 = { class: "mb-0 text-sm" }
const _hoisted_45 = { class: "text-xs text-secondary mb-0" }
const _hoisted_46 = {
  key: 0,
  class: "text-success me-1"
}
const _hoisted_47 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_48 = { class: "align-middle text-center text-sm" }
const _hoisted_49 = { class: "align-middle text-center" }
const _hoisted_50 = { class: "text-secondary text-xs font-weight-bold" }
const _hoisted_51 = { class: "align-middle text-center" }
const _hoisted_52 = { class: "text-secondary text-xs font-weight-bold" }
const _hoisted_53 = { class: "align-middle text-center" }
const _hoisted_54 = { class: "text-secondary text-xs font-weight-bold" }
const _hoisted_55 = { class: "align-middle" }
const _hoisted_56 = { class: "d-flex align-items-center gap-1 px-1" }
const _hoisted_57 = { class: "form-check form-switch mb-0 d-flex align-items-center" }
const _hoisted_58 = ["checked", "id", "disabled"]
const _hoisted_59 = {
  key: 0,
  class: "spinner-border spinner-border-sm text-secondary ms-1",
  role: "status",
  "aria-hidden": "true"
}
const _hoisted_60 = ["title", "onClick"]
const _hoisted_61 = { class: "container mt-2" }

import { ref, computed, watchEffect, nextTick, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import DateHelper from '@/helpers/DateHelper'
import DriverRepository from '@/repositories/DriverRepository'
import { useDriversStore } from '@/services/stores/DriversStore'
import AuthService from '@/services/AuthService'
import ToastService from '@/services/ToastService'
import i18n from '@/plugins/i18n'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import { Modal } from 'bootstrap'
import { DriverInterface } from '@/types/DriverInterface'
import type { ActiveFilters } from '@/types/ActiveFilters'
import DriverFiltersBar from '@/components/drivers/DriverFiltersBar.vue'
import PagePaginator from '@/components/PagePaginator.vue'
import SendFcmModal from '@/views/drivers/SendFCMModal.vue'
import CreateDriverModal from '@/views/drivers/CreateDriverModal.vue'

const BOGOTA_TIMEZONE = 'America/Bogota'
const DEFAULT_SORT = 'name'
const DEFAULT_PAGE = 1
const DEFAULT_PER_PAGE = 30

// ── Router / route ────────────────────────────────────────────────────────────


export default /*@__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

dayjs.extend(utc)
dayjs.extend(timezone)

// ── Constants ─────────────────────────────────────────────────────────────────

const route = useRoute()
const router = useRouter()

// ── Store (map/connected drivers — untouched) ─────────────────────────────────

const { findById } = useDriversStore()
// Note: DriversStore.filter() is no longer used here; it has no other consumers.

// ── Auth ──────────────────────────────────────────────────────────────────────

const currentUser = AuthService.getCurrentUser()

// ── URL-derived state ─────────────────────────────────────────────────────────

function parseSort(raw: string | undefined): { field: string; dir: 'asc' | 'desc' } {
  if (!raw) return { field: 'name', dir: 'asc' }
  if (raw.startsWith('-')) return { field: raw.slice(1), dir: 'desc' }
  return { field: raw, dir: 'asc' }
}

const PERIOD_FORMAT = /^\d{4}-(0[1-9]|1[0-2])$/

function parseFilters(q: typeof route.query): ActiveFilters {
  const f: ActiveFilters = {}
  if (q.status === 'enabled' || q.status === 'disabled') f.status = q.status
  if (q.paymentMode === 'monthly' || q.paymentMode === 'percentage') f.paymentMode = q.paymentMode
  if (q.paymentStatus === 'paid' || q.paymentStatus === 'pending') {
    f.paymentStatus = q.paymentStatus
    const period = typeof q.period === 'string' ? q.period : ''
    f.period = PERIOD_FORMAT.test(period) ? period : dayjs().tz(BOGOTA_TIMEZONE).format('YYYY-MM')
  }
  if (q.inactiveDays) {
    const n = Number(q.inactiveDays)
    if (n > 0) f.inactiveDays = n
  }
  return f
}

const initialSort = parseSort(route.query.sort as string | undefined)
const sortField = ref<string>(initialSort.field)
const sortDir = ref<'asc' | 'desc'>(initialSort.dir)
const search = ref<string>((route.query.search as string) || '')
const filters = ref<ActiveFilters>(parseFilters(route.query))
const page = ref<number>(route.query.page ? Math.max(1, Number(route.query.page)) : DEFAULT_PAGE)
const perPage = ref<number>(
  route.query.perPage ? Number(route.query.perPage) : DEFAULT_PER_PAGE
)

// ── Debounce helpers ──────────────────────────────────────────────────────────

// The committed search value that drives fetches. Updated either by debounce or
// immediate flush so that non-search interactions do not race a pending debounce.
const committedSearch = ref<string>(search.value)
let debounceTimer: ReturnType<typeof setTimeout> | null = null

function flushSearch(): void {
  if (debounceTimer !== null) {
    clearTimeout(debounceTimer)
    debounceTimer = null
  }
  committedSearch.value = search.value
}

function scheduleSearchCommit(): void {
  if (debounceTimer !== null) clearTimeout(debounceTimer)
  debounceTimer = setTimeout(() => {
    committedSearch.value = search.value
    debounceTimer = null
    commitUrlState()
  }, 300)
}

// ── Sort helper ───────────────────────────────────────────────────────────────

const sortParam = computed<string>(() =>
  sortDir.value === 'desc' ? `-${sortField.value}` : sortField.value
)

function setSort(field: string): void {
  flushSearch()
  if (sortField.value === field) {
    sortDir.value = sortDir.value === 'asc' ? 'desc' : 'asc'
  } else {
    sortField.value = field
    sortDir.value = 'asc'
  }
  page.value = 1
  clearSelection()
  commitUrlState()
}

// ── URL state commit ──────────────────────────────────────────────────────────

function commitUrlState(): void {
  const q: Record<string, string | undefined> = {}

  if (committedSearch.value !== '') q.search = committedSearch.value
  if (filters.value.status !== undefined) q.status = filters.value.status
  if (filters.value.paymentMode !== undefined) q.paymentMode = filters.value.paymentMode
  if (filters.value.paymentStatus !== undefined) {
    q.paymentStatus = filters.value.paymentStatus
    if (filters.value.period !== undefined) q.period = filters.value.period
  }
  if (filters.value.inactiveDays !== undefined) q.inactiveDays = String(filters.value.inactiveDays)
  if (sortParam.value !== DEFAULT_SORT) q.sort = sortParam.value
  if (page.value !== DEFAULT_PAGE) q.page = String(page.value)
  if (perPage.value !== DEFAULT_PER_PAGE) q.perPage = String(perPage.value)

  if (!hasSameQuery(q)) {
    void router.replace({ query: q })
  }
}

function hasSameQuery(nextQuery: Record<string, string | undefined>): boolean {
  const currentQuery = Object.entries(route.query).reduce<Record<string, string>>((acc, [key, value]) => {
    if (typeof value === 'string') {
      acc[key] = value
    }
    return acc
  }, {})
  const normalizedNextQuery = Object.entries(nextQuery).reduce<Record<string, string>>((acc, [key, value]) => {
    if (value !== undefined) {
      acc[key] = value
    }
    return acc
  }, {})

  const currentKeys = Object.keys(currentQuery).sort()
  const nextKeys = Object.keys(normalizedNextQuery).sort()
  if (currentKeys.length !== nextKeys.length) return false

  return nextKeys.every((key, index) => currentKeys[index] === key && currentQuery[key] === normalizedNextQuery[key])
}

// ── Event handlers from DriverFiltersBar ──────────────────────────────────────

function onSearchUpdate(value: string): void {
  search.value = value
  page.value = 1
  clearSelection()
  scheduleSearchCommit()
}

function onFiltersUpdate(value: ActiveFilters): void {
  flushSearch()
  filters.value = value
  page.value = 1
  clearSelection()
  commitUrlState()
}

// ── Paginator event handlers ──────────────────────────────────────────────────

function onPageUpdate(value: number): void {
  flushSearch()
  page.value = value
  clearSelection()
  commitUrlState()
}

function onPerPageUpdate(value: number): void {
  flushSearch()
  perPage.value = value
  page.value = 1  // page size change resets to page 1
  clearSelection()
  commitUrlState()
}

// ── Data state ────────────────────────────────────────────────────────────────

const rows = ref<DriverInterface[]>([])
const total = ref<number>(0)
const loading = ref<boolean>(false)

// Incrementing counter used to force a re-fetch after bulk actions
// without changing any filter/sort/page state.
const fetchTick = ref<number>(0)

function triggerRefetch(): void {
  fetchTick.value += 1
}

// ── Fetch logic ───────────────────────────────────────────────────────────────

watchEffect(async () => {
  // Capture reactive dependencies
  void fetchTick.value  // tracked to allow forced refetch
  const _search = committedSearch.value
  const _status = filters.value.status
  const _paymentMode = filters.value.paymentMode
  const _paymentStatus = filters.value.paymentStatus
  const _period = filters.value.period
  const _inactiveDays = filters.value.inactiveDays
  const _sort = sortParam.value
  const _page = page.value
  const _perPage = perPage.value

  loading.value = true
  try {
    const result = await DriverRepository.list({
      search: _search || undefined,
      status: _status,
      paymentMode: _paymentMode,
      paymentStatus: _paymentStatus,
      period: _period,
      inactiveDays: _inactiveDays,
      sort: _sort,
      page: _page,
      perPage: _perPage,
    })
    rows.value = result.drivers
    total.value = result.total

    // Clamp page if overshoot
    if (result.total > 0 && (_page - 1) * _perPage >= result.total) {
      page.value = 1
      commitUrlState()
    }
  } catch (e: any) {
    ToastService.toast(ToastService.ERROR, i18n.global.t('common.messages.error'), e?.message)
  } finally {
    loading.value = false
  }
})

// ── Selection state ───────────────────────────────────────────────────────────

const selectedIds = ref<Set<string>>(new Set())

function clearSelection(): void {
  selectedIds.value = new Set()
}

function onMasterCheckbox(event: Event): void {
  const checked = (event.target as HTMLInputElement).checked
  if (checked) {
    selectedIds.value = new Set(rows.value.map(d => d.id))
  } else {
    selectedIds.value = new Set()
  }
}

function onRowCheckbox(id: string): void {
  const next = new Set(selectedIds.value)
  if (next.has(id)) {
    next.delete(id)
  } else {
    next.add(id)
  }
  selectedIds.value = next
}

// ── Per-row enable/disable (existing single-driver flow) ──────────────────────

// Keyed by driver id so toggling one row's switch never disables its siblings.
const togglingIds = ref<Set<string>>(new Set())

function onEnable(event: Event): void {
  const target = event.target as HTMLInputElement
  const driver = findById(target.id) ?? ({ id: target.id, enabled_at: 0 } as any)
  if (togglingIds.value.has(driver.id)) return
  togglingIds.value.add(driver.id)
  const enabledAt = target.checked ? dayjs().unix() : 0
  DriverRepository.enable(driver.id, enabledAt)
    .then(() => {
      togglingIds.value.delete(driver.id)
      const message =
        enabledAt === 0
          ? i18n.global.t('users.messages.disabled')
          : i18n.global.t('users.messages.enabled')
      ToastService.toast(ToastService.SUCCESS, message)
    })
    .catch((e: any) => {
      togglingIds.value.delete(driver.id)
      ToastService.toast(ToastService.ERROR, i18n.global.t('common.messages.error'), e.message)
    })
}

// ── Single-driver send message modal ─────────────────────────────────────────

const sendFcmModal = ref<Modal | null>(null)
const messageTo = ref<DriverInterface | null>(null)

async function showSendMessageModal(driver: DriverInterface | null = null): Promise<void> {
  messageTo.value = driver
  await nextTick()
  sendFcmModal.value = new Modal(document.getElementById('send-fcm-modal') as HTMLElement)
  sendFcmModal.value.show()
}

function closeSendMessageModal(): void {
  if (sendFcmModal.value) {
    sendFcmModal.value.hide()
  }
  messageTo.value = null
}

// ── Create driver modal ───────────────────────────────────────────────────────

const createDriverModal = ref<Modal | null>(null)
const createModalOpen = ref(false)

async function showCreateDriverModal(): Promise<void> {
  createModalOpen.value = true
  await nextTick()
  const el = document.getElementById('create-driver-modal')
  if (el) {
    createDriverModal.value = new Modal(el)
    createDriverModal.value.show()
  }
}

function closeCreateDriverModal(): void {
  if (createDriverModal.value) {
    createDriverModal.value.hide()
  }
  createDriverModal.value = null
  createModalOpen.value = false
}

function onDriverCreated(): void {
  triggerRefetch()
}

// ── Bulk actions ──────────────────────────────────────────────────────────────

const bulkSendFcmModal = ref<Modal | null>(null)
const bulkModalOpen = ref(false)

async function bulkSendMessage(): Promise<void> {
  bulkModalOpen.value = true
  await nextTick()
  const el = document.getElementById('send-fcm-modal')
  if (el) {
    bulkSendFcmModal.value = new Modal(el)
    bulkSendFcmModal.value.show()
  }
}

function closeBulkSendModal(): void {
  if (bulkSendFcmModal.value) {
    bulkSendFcmModal.value.hide()
  }
  bulkModalOpen.value = false
  clearSelection()
  triggerRefetch()
}

const bulkDisabling = ref(false)

async function bulkDisable(): Promise<void> {
  const ids = Array.from(selectedIds.value)
  const confirmed = window.confirm(
    i18n.global.t('drivers.bulk.disable_confirm', { count: ids.length })
  )
  if (!confirmed) return

  bulkDisabling.value = true
  try {
    const result = await DriverRepository.bulkDisable(ids)
    const message = i18n.global.t('drivers.bulk.disable_result', {
      processed: result.processed,
      failed: result.failed.length,
    })
    ToastService.toast(result.failed.length === 0 ? ToastService.SUCCESS : ToastService.ERROR, message)
  } catch (e: any) {
    ToastService.toast(ToastService.ERROR, i18n.global.t('common.messages.error'), e?.message)
  } finally {
    bulkDisabling.value = false
    clearSelection()
    triggerRefetch()
  }
}

// ── Helpers ───────────────────────────────────────────────────────────────────

function format(unix: number): string {
  return DateHelper.unixToDate(unix, 'YYYY-MM-DD')
}

function selectedVehiclePhotoUrl(driver: DriverInterface): string | null {
  const photoUrl = driver.selected_vehicle?.photoUrl
  if (typeof photoUrl !== 'string') {
    return null
  }

  const trimmed = photoUrl.trim()
  return trimmed === '' ? null : trimmed
}

onMounted(() => {
  commitUrlState()
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_unref(currentUser) && _unref(currentUser).isAdmin())
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("h6", _hoisted_5, "Drivers · " + _toDisplayString(total.value), 1)
            ]))
          : _createCommentVNode("", true),
        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "col" }, null, -1)),
        (_unref(currentUser) && _unref(currentUser).isAdmin())
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(_component_router_link, {
                to: { name: 'drivers.payments' },
                tag: "a",
                class: "btn btn-sm btn-outline-dark btn-rounded mb-0"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('drivers.payments_audit.entry_label')), 1)
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("button", {
            class: "btn btn-sm bg-gradient-warning mb-0",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (showSendMessageModal()))
          }, [
            _cache[5] || (_cache[5] = _createElementVNode("em", {
              class: "fas fa-paper-plane me-1",
              "aria-hidden": "true"
            }, null, -1)),
            _createTextVNode(_toDisplayString(_ctx.$t('common.actions.send_message')), 1)
          ]),
          (_openBlock(), _createBlock(SendFcmModal, {
            key: messageTo.value?.id ?? 'broadcast',
            ref_key: "sendFcmModal",
            ref: sendFcmModal,
            driver: messageTo.value,
            onClose: closeSendMessageModal
          }, null, 8, ["driver"]))
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-sm bg-gradient-primary btn-rounded mb-0",
            "data-original-title": "Create Driver",
            onClick: showCreateDriverModal
          }, [...(_cache[6] || (_cache[6] = [
            _createElementVNode("em", { class: "fas fa-plus" }, null, -1)
          ]))]),
          (createModalOpen.value)
            ? (_openBlock(), _createBlock(CreateDriverModal, {
                key: 0,
                onClose: closeCreateDriverModal,
                onCreated: onDriverCreated
              }))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(DriverFiltersBar, {
          filters: filters.value,
          search: search.value,
          "onUpdate:filters": onFiltersUpdate,
          "onUpdate:search": onSearchUpdate
        }, null, 8, ["filters", "search"])
      ]),
      (selectedIds.value.size > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("span", _hoisted_11, _toDisplayString(selectedIds.value.size) + " " + _toDisplayString(_ctx.$t('drivers.bulk.selected')), 1),
            _cache[8] || (_cache[8] = _createElementVNode("span", { class: "text-secondary" }, "·", -1)),
            _createElementVNode("button", {
              class: "btn btn-sm btn-outline-secondary",
              onClick: bulkSendMessage
            }, _toDisplayString(_ctx.$t('common.actions.send_message')), 1),
            _createElementVNode("button", {
              class: "btn btn-sm btn-outline-danger",
              onClick: bulkDisable,
              disabled: bulkDisabling.value
            }, [
              (bulkDisabling.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_13))
                : _createCommentVNode("", true),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('common.fields.disabled')), 1)
            ], 8, _hoisted_12),
            (bulkModalOpen.value)
              ? (_openBlock(), _createBlock(SendFcmModal, {
                  key: "bulk-send",
                  ref_key: "bulkSendFcmModal",
                  ref: bulkSendFcmModal,
                  "driver-ids": Array.from(selectedIds.value),
                  onClose: closeBulkSendModal
                }, null, 8, ["driver-ids"]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          (loading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _cache[9] || (_cache[9] = _createElementVNode("em", { class: "fas fa-circle-notch fa-spin me-1" }, null, -1)),
                _createTextVNode(_toDisplayString(_ctx.$t('common.messages.waiting')), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("table", {
            class: _normalizeClass(["table align-items-center mb-0", { 'opacity-50': loading.value }])
          }, [
            _cache[13] || (_cache[13] = _createElementVNode("caption", { hidden: "" }, null, -1)),
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      class: "form-check-input",
                      checked: rows.value.length > 0 && selectedIds.value.size === rows.value.length,
                      ".indeterminate": selectedIds.value.size > 0 && selectedIds.value.size < rows.value.length,
                      onChange: onMasterCheckbox
                    }, null, 40, _hoisted_19)
                  ])
                ]),
                _createElementVNode("th", {
                  class: "text-uppercase text-secondary text-xxs font-weight-bolder cursor-pointer user-select-none",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (setSort('name')))
                }, [
                  _createTextVNode(_toDisplayString(_ctx.$t('common.fields.name')) + " ", 1),
                  (sortField.value === 'name')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(sortDir.value === 'asc' ? '↑' : '↓'), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("th", _hoisted_21, _toDisplayString(_ctx.$t('common.fields.phone')), 1),
                _createElementVNode("th", _hoisted_22, _toDisplayString(_ctx.$t('drivers.fields.vehicle')), 1),
                _createElementVNode("th", _hoisted_23, _toDisplayString(_ctx.$t('drivers.fields.plate')), 1),
                _createElementVNode("th", _hoisted_24, _toDisplayString(_ctx.$t('common.fields.status')), 1),
                _createElementVNode("th", {
                  class: "text-uppercase text-secondary text-xxs font-weight-bolder cursor-pointer user-select-none",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (setSort('created_at')))
                }, [
                  _createTextVNode(_toDisplayString(_ctx.$t('common.fields.createdAt')) + " ", 1),
                  (sortField.value === 'created_at')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(sortDir.value === 'asc' ? '↑' : '↓'), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("th", {
                  class: "text-uppercase text-secondary text-xxs font-weight-bolder cursor-pointer user-select-none",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (setSort('last_connection')))
                }, [
                  _createTextVNode(_toDisplayString(_ctx.$t('common.fields.lastConnection')) + " ", 1),
                  (sortField.value === 'last_connection')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(sortDir.value === 'asc' ? '↑' : '↓'), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("th", {
                  class: "text-uppercase text-secondary text-xxs font-weight-bolder cursor-pointer user-select-none",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (setSort('balance')))
                }, [
                  _createTextVNode(_toDisplayString(_ctx.$t('drivers.fields.balance')) + " ", 1),
                  (sortField.value === 'balance')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(sortDir.value === 'asc' ? '↑' : '↓'), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("th", _hoisted_28, _toDisplayString(_ctx.$t('common.actions.edit')), 1)
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rows.value, (driver) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: driver.id
                }, [
                  _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("input", {
                        type: "checkbox",
                        class: "form-check-input",
                        checked: selectedIds.value.has(driver.id),
                        onChange: ($event: any) => (onRowCheckbox(driver.id))
                      }, null, 40, _hoisted_30)
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_31, [
                    _createElementVNode("div", _hoisted_32, [
                      _createElementVNode("div", null, [
                        (driver.photoUrl)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: driver.photoUrl,
                              class: "avatar avatar-sm me-3",
                              alt: "Profile"
                            }, null, 8, _hoisted_33))
                          : (_openBlock(), _createElementBlock("div", _hoisted_34, [...(_cache[10] || (_cache[10] = [
                              _createElementVNode("em", { class: "fas fa-user-astronaut text-white text-xs" }, null, -1)
                            ]))]))
                      ]),
                      _createElementVNode("div", _hoisted_35, [
                        _createElementVNode("h6", _hoisted_36, _toDisplayString(driver.name), 1),
                        _createElementVNode("p", _hoisted_37, _toDisplayString(driver.email), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("p", _hoisted_38, _toDisplayString(driver.phone), 1)
                  ]),
                  _createElementVNode("td", _hoisted_39, [
                    _createElementVNode("div", _hoisted_40, [
                      (selectedVehiclePhotoUrl(driver))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                            _createElementVNode("img", {
                              src: selectedVehiclePhotoUrl(driver) || undefined,
                              class: "avatar avatar-sm me-3",
                              alt: "Vehicle"
                            }, null, 8, _hoisted_42)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_43, [
                        _createElementVNode("h6", _hoisted_44, _toDisplayString(driver.selected_vehicle?.brand), 1),
                        _createElementVNode("p", _hoisted_45, _toDisplayString(driver.selected_vehicle?.model), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("td", null, [
                    (driver.selected_vehicle)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          (driver.active_vehicle_id)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_46, "●"))
                            : _createCommentVNode("", true),
                          _createVNode(_component_router_link, {
                            to: { name: 'vehicles.detail', params: { id: driver.selected_vehicle_id } }
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(driver.selected_vehicle.plate), 1)
                            ]),
                            _: 2
                          }, 1032, ["to"])
                        ], 64))
                      : (_openBlock(), _createElementBlock("span", _hoisted_47, "—"))
                  ]),
                  _createElementVNode("td", _hoisted_48, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["gorda-status-badge", driver.enabled_at ? 'gorda-status-badge--success' : 'gorda-status-badge--danger'])
                    }, _toDisplayString(_ctx.$t(driver.enabled_at ? 'common.fields.enabled' : 'common.fields.disabled')), 3)
                  ]),
                  _createElementVNode("td", _hoisted_49, [
                    _createElementVNode("span", _hoisted_50, _toDisplayString(format(driver.created_at)), 1)
                  ]),
                  _createElementVNode("td", _hoisted_51, [
                    _createElementVNode("span", _hoisted_52, _toDisplayString(format(driver.last_connection)), 1)
                  ]),
                  _createElementVNode("td", _hoisted_53, [
                    _createElementVNode("span", _hoisted_54, _toDisplayString(driver.balance), 1)
                  ]),
                  _createElementVNode("td", _hoisted_55, [
                    _createElementVNode("div", _hoisted_56, [
                      _createElementVNode("div", _hoisted_57, [
                        _createElementVNode("input", {
                          class: "form-check-input",
                          name: "enable",
                          type: "checkbox",
                          role: "switch",
                          checked: driver.enabled_at > 0,
                          id: driver.id,
                          disabled: togglingIds.value.has(driver.id),
                          onChange: onEnable
                        }, null, 40, _hoisted_58),
                        (togglingIds.value.has(driver.id))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_59))
                          : _createCommentVNode("", true)
                      ]),
                      _createVNode(_component_router_link, {
                        to: { name: 'drivers.edit', params: { id: driver.id } },
                        tag: "a",
                        class: "btn btn-sm btn-outline-primary px-2",
                        title: _ctx.$t('common.actions.edit')
                      }, {
                        default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                          _createElementVNode("em", { class: "fas fa-pencil" }, null, -1)
                        ]))]),
                        _: 1
                      }, 8, ["to", "title"]),
                      _createElementVNode("button", {
                        class: "btn btn-sm btn-outline-secondary px-2",
                        title: _ctx.$t('common.actions.send_message'),
                        onClick: ($event: any) => (showSendMessageModal(driver))
                      }, [...(_cache[12] || (_cache[12] = [
                        _createElementVNode("em", { class: "fas fa-paper-plane" }, null, -1)
                      ]))], 8, _hoisted_60)
                    ])
                  ])
                ]))
              }), 128))
            ])
          ], 2),
          _createElementVNode("div", _hoisted_61, [
            _createVNode(PagePaginator, {
              total: total.value,
              page: page.value,
              "per-page": perPage.value,
              "onUpdate:page": onPageUpdate,
              "onUpdate:perPage": onPerPageUpdate
            }, null, 8, ["total", "page", "per-page"])
          ])
        ])
      ])
    ])
  ]))
}
}

})